<template>
    <div :style="`display: inline-block; width: ${width || '100%'}`">

        <v-text-field
                v-if="asTextField"
                readonly
                clearable
                @click:clear="clear"
                :error-messages="errorMessages || null"
                v-model="formattedDate"
                :label="label || 'Seleccionar fecha'"
                @click="show" />

        <v-btn v-else depressed rounded small style="margin:auto; width: 100%"  @click="show" full-width>
            <v-icon size="18" class="mr-2">mdi-calendar</v-icon>
            {{formattedDate}}
        </v-btn>

        <v-dialog
            ref="dialog"
            v-model="modal"
            width="290px"
        >
            <v-date-picker locale="es-es" v-model="date" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="default" @click="hide">Cancelar</v-btn>
            </v-date-picker>
        </v-dialog>
    </div>

</template>
<script>
    export default{
        props: ['value', 'calendar', 'inputMode', 'label', 'errorMessages', 'width'],
        data(vm){
            return {
                modal: false,
                date: vm.value && vm.$moment(vm.value).format('YYYY-MM-DD') || ''
            }
        },
        methods: {
            clear(){
                var vm = this
                vm.date = ''
                vm.$emit('change', '')
            },
            selectDate(){
                var vm = this
                vm.$emit('change', vm.date)
                vm.hide()
            },
            show(){
                this.modal = true
            },
            hide(){
                this.modal = false
            }
        },
        computed:{
            asTextField(){
                return this.inputMode !== undefined && this.inputMode !== false
            },
            asCalendar(){
                return this.calendar !== undefined && this.calendar !== false

            },
            formattedDate: {
                get(){
                    var vm = this

                    if(!vm.date) return ''

                    if(!vm.asCalendar){
                        return vm.$moment(vm.date).format('DD-MM-YYYY')
                    }

                    return vm.$moment(vm.date).calendar(null,{
                        lastDay : '[Ayer]',
                        sameDay : '[Hoy]',
                        nextDay : '[Mañana]',
                        lastWeek : '[Pasado] dddd',
                        nextWeek : '[Próximo] dddd',
                        sameElse : 'DD-MM-YYYY'
                    }) //.format('DD-MM-YYYY')
                },
                set(val)
                {
                    var vm = this
                    vm.date = val ? vm.$moment(val).format('YYYY-MM-DD') : ''
                }
            }
        },
        watch: {
            value(val){
                var vm = this
                vm.date = val ? vm.$moment(val).format('YYYY-MM-DD') : ''
            },
          date(val){
              if(val) this.selectDate()
          }
        }
    }
</script>
